// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N7Sf","colBig":"styles_colBig__2ex92","colSmall":"styles_colSmall__34YrK"};